// extracted by mini-css-extract-plugin
export default {"home_container":"Home_home_container__3FDjK","home_title":"Home_home_title__xVRVd"};